module.exports = __webpack_public_path__ + "img/HFIG-600-frequencydomain.0355182bd4d29341077ca2f8aa4d3a82.avif";